export const countArrayGroupBy = (arrayobjects, fieldGroup) => {
  let objectGroup = groupByArrayObject(arrayobjects, fieldGroup);
  return Object.keys(objectGroup).length;
};

export const groupByArrayObject = (arrayobjects, fieldGroup) => {
  return arrayobjects.reduce((group, product) => {
    const category = product[fieldGroup];
    group[category] = group[category] ?? [];
    group[category].push(product);
    return group;
  }, {});
};

export const pluckArrayObject = (objArray, fieldName) => {
  return objArray.map(a => a[fieldName]);
};
